import { mapBaseUrl } from 'core/constant/map/mapBaseUrl';

export const getGoogleMapUrl = (lat: number, lng: number) => {
    const parameters = `query=${lat},${lng}`;
    return encodeURI(`${mapBaseUrl.GoogleMapActionSearch}&${parameters}`);
};
